import ResourceListsEmptyState from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/resource_lists/empty_state.vue?vue3';
import { s__ } from '~/locale';
import { SEARCH_MINIMUM_LENGTH } from '../../constants';
export default {
    name: 'InactiveSubgroupsAndProjectsEmptyState',
    components: {
        ResourceListsEmptyState
    },
    SEARCH_MINIMUM_LENGTH,
    i18n: {
        title: s__('GroupsEmptyState|There are no inactive subgroups or projects in this group'),
        description: s__('GroupsEmptyState|Subgroups and projects that are archived or pending deletion will appear here.')
    },
    inject: [
        'emptyProjectsIllustration'
    ],
    props: {
        search: {
            type: String,
            required: false,
            default: ''
        }
    }
};
